import * as React from 'react'
import { Props } from './types'

import './styles.scss'

export class WrapperTooltip extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    this.state = {}
  }

  render() {
    const { children, value } = this.props
    return (
      <span className="wrapperTooltip" data-tooltip={value}>
        { children }
      </span>
    )
  }
}